import axios, { AxiosInstance } from 'axios';

import { getClientKey } from '@/lib/utils/getClientKey';

const baseURL = import.meta.env.VITE_API_BASE_URL;

if (!baseURL) {
  throw new Error(
    'VITE_API_BASE_URL is not defined in the environment variables.'
  );
}

const apiClient: AxiosInstance = axios.create({
  baseURL,
});

apiClient.interceptors.request.use(
  async (config) => {
    const isProd = import.meta.env.VITE_ENV_INSTANCE === 'PROD';

    if (!isProd) {
      const apiKey = getClientKey();
      if (apiKey) {
        config.headers['x-api-key'] = apiKey;
      }
    }

    return config;
  },
  (error) => {
    if (import.meta.env.VITE_DEV_MODE === 'true') {
      console.error('Request error:', error);
    }
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (import.meta.env.VITE_DEV_MODE === 'true') {
      console.error('Response error:', error.response || error.message);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
